import { Theme } from '@mui/material';
/**
 *
 * @param theme -
 * @returns
 * @example styles added for toast messages
 */
const appToastStyles = (theme: Theme) => {
  const styles = {
    toast: {
      '#AppToastContainer .Toastify__toast': {
        background: theme.palette.background.paper,
        width: '320px',
      },
      '#AppToastContainer .Toastify__toast-container': {
        [theme.breakpoints.down('xl')]: {
          top: '22%',
          left: '50%',
          transform: 'translateX(-50%)',
        },
        margin: '0 auto',
        width: 'fit-content',
      },
      '#AppToastContainer .Toastify__toast-body': {
        margin: 'auto 0px',
        flex: '1 1 auto',
        padding: '6px',
        display: 'flex',
        alignItems: 'flex-start',
      },
      '#AppToastContainer .Toastify__toast-icon': {
        position: 'relative',
        marginTop: '2px',
      },
      '#ComponentToastContainer .Toastify__toast-container, #ToolTipToastContainer .Toastify__toast-container':
        {
          position: 'absolute',
          padding: '0px',
          [theme.breakpoints.down('md')]: {
            width: '80vw',
          },
          [theme.breakpoints.down(481)]: {
            width: '80vw',
            left: 0,
            right: 0,
            margin: '0 auto',
          },
        },
      '#ToolTipToastContainer .Toastify__toast-container:after': {
        content: '""',
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        marginLeft: '-5px',
        borderWidth: '5px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent #444d57',
      },
      '.Toastify__toast--warning': {
        svg: {
          fill: theme.palette?.error.main,
        },
      },
      '.publicMessageToast.Toastify__toast--success, .publicMessageToast.Toastify__toast--error':
        {
          svg: {
            fill: '#f8fafb',
          },
        },
      '#ToolTipToastContainer .Toastify__toast': {
        background: '#444d57',
      },
      '#ToolTipToastContainer .Toastify__toast-icon': {
        svg: {
          fill: 'white',
        },
      },
      '#ToolTipToastContainer .Toastify__toast-body div': {
        color: 'white',
        marginBottom: '0px',
      },
      '#AgentMessageToastContainer .Toastify__toast': {
        maxHeight: '53vh',
        overflow: 'auto',
        cursor: 'unset',
        borderRadius: '4px',
        marginBottom: '1rem',
      },
      '#AppToastContainer .publicMessageToast.Toastify__toast--success': {
        background: theme.palette.success.dark,
      },
      '#AppToastContainer .publicMessageToast.Toastify__toast--success .text, #AppToastContainer .publicMessageToast.Toastify__toast--error .text':
        {
          color: '#f8fafb',
        },
      '#AppToastContainer .publicMessageToast.Toastify__toast--error': {
        background: theme.palette.error.main,
      },
      '#AgentMessageToastContainer>.Toastify__toast-container': {
        position: 'relative',
        top: '4.75em',
        left: '0em',
        width: '330px',
        padding: '4px',
        [theme.breakpoints.down('xl')]: {
          top: '5.75em',
        },
      },
      '#AgentMessageToastContainer>.Toastify__toast-container--bottom-right': {
        bottom: '1em',
        right: '1em',
        top: 'unset',
      },
      '#DirectoryToastContainer .Toastify__toast-container, #ToolTipToastContainer .Toastify__toast-container':
        {
          position: 'absolute',
          padding: '0px',
          width: '100%',
        },
      '#DirectoryToastContainer .Toastify__toast-icon': {
        position: 'relative',
        marginBottom: '3.5em',
      },
      '#DirectoryToastContainer .Toastify__toast--warning': {
        background: '#fdeeef',
      },
      '.publicMessageToast .Toastify__close-button': {
        alignSelf: 'auto',
      },
      '.publicMessageToast .text,.publicMessageToast .titleText,.publicMessageToast .subMessageText':
        {
          marginBottom: '0px',
        },
      '@media only screen and (max-width: 480px)': {
        '#AppToastContainer .removeCommitmentConfirmToast': {
          top: '1rem',
          width: '90%',
          margin: '0 auto',
          borderRadius: '5px',
        },
      },
    },
  };
  return styles;
};
export default appToastStyles;
